export const errors = {
  enter_valid_email: 'Please, enter a valid email address.',
  email_required: 'The Email is required.',
  phone_required: 'The Phone Number is required.',
  role_required: 'The Role is required.',
  name_required: 'The Name is required.',
  firstname_required: 'The First Name is required.',
  min_2_char_required: 'Minimum 2 characters are required.',
  min_3_char_required: 'Minimum 3 characters are required.',
  min_5_char_required: 'Minimum 5 characters are required.',
  lastname_required: 'The Last Name is required.',
  phone_number_digit: 'Please, enter a 10-digit phone number.',
  add_success: 'Added Successfully.',
  delete_success: 'Deleted Successfully.',
  details_update_success: 'Details updated successfully.',
  vault_key_required: 'The Coop (digital vault) Key is required.',
  vault_key_invalid: 'The Coop (digital vault) Key is invalid.',
  vault_exists: 'A verified Coop (digital vault) already exists.',
  verify_new_key:
    'There is a new key in progress that must be verified or canceled.',
  check_passphrase: 'Please check your passphrase.',
  security_code_required: 'The Security code is required.',
  entered_code_invalid: 'The code entered was invalid.',
  address_required: 'The Address Line is required.',
  city_required: 'The City is required.',
  state_required: 'The State is required.',
  reportedDeathWaitTime_required: 'The Wait Period is required.',
  reportedDeathWaitTime_add_success: ' Wait Period added successfully.',
  zip_required: 'The 5 digit Zip code is required.',
  zip_nine_digit: 'The Zip code must be 5 digits.',
  spouse_required: 'The Spouse information is required.',
  citizenship_required: 'The Citizenship is required.',
  electronic_guardian_availability:
    'The Electronic Guardian is currently only available to residents of the United States.',
  resend_security_code: 'Resend security code.',
  request_another_code: 'Please wait 1 minute to request another code.',
  incorrect_key: 'The key is incorrect, try again.',
  description_required: 'The Description is required.',
  mail_further_information:
    "We'll send you an email with further information to continue your process.",
  label_required: 'The Label is required.',
  tax_document_type_required: 'The Tax Document Type is required.',
  tax_return_type_required: 'The Tax Return Type is required.',
  tax_basis_type_required: 'The Tax Basis Type is required.',
  identification_type_required: 'The Identification Type is required.',
  url_required: 'The Url is required.',
  username_required: 'The Username is required.',
  password_required: 'The Password is required.',
  institution_required: 'The Institution is required.',
  accountant_contact_required: 'The Accountant Contact is required.',
  assets_invalid: 'Provided Asset(s) are invalid.',
  liabilities_invalid: 'Provided liability(es) are invalid.',
  account_required: 'The Account type is required.',
  more_than_200_char_not_allowed: 'More than 200 characters are not allowed.',
  more_than_50_char_not_allowed: 'More than 50 characters are not allowed.',
  max_250_char_required: 'Maximum 250 characters are required.',
  max_200_char_required: 'Maximum 200 characters are required.',
  company_required: 'The Company is required.',
  customer_number_required: 'The Customer number is required.',
  policies_invalid: 'Provided policy(s) are invalid.',
  trustee_invalid: 'Provided trustee(s) are invalid.',
  beneficiary_exclusive:
    "A contact can't be primary and secondary beneficiary at the same time.",
  title_required: 'The Title is required.',
  company_name_required: 'The Company Name is required.',
  contact_name_required: 'The Contact Name is required.',
  video_required: 'A video must be uploaded.',
  policy_number_required: 'The Policy number is required.',
  purchase_date_required: 'The Purchase date is required.',
  loans_invalid: 'Provided loans(s) are invalid.',
  date_signed_required: 'The Date signed is required.',
  payment_successful: 'The payment is successful.',
  no_payment_type: 'No payment type is defined.',
  address_add_successful: 'The Address is added successfully.',
  feedback_submit_success: 'Your feedback is submitted successfully.',
  can_not_submit_feedback: 'Can not submit your feedback.',
  payment_enquery_submit_success:
    'Your payment enquery is submitted successfully.',
  can_not_submit_payment_enquery: 'Can not submit your payment enquery.',
  failed_upload_file: 'Failed to upload the file(s).',
  participation_accepted: 'Your participation is accepted.',
  profile_updated_success: 'The profile is updated successfully.',
  add_multimedia_success: 'Successfully added a new video.',
  add_multimedia_fail: 'Failed to add a new video.',
  video_update_success: 'The video is updated successfully.',
  add_will_success: 'The Will is added successfully.',
  add_will_fail: 'An error occurred when updating the Will.',
  video_upto_5GB: 'You can upload video formats up to 5GB only.',
  file_upto_20MB: 'You can upload a file up to 20MB only.',
  login_again: 'Please log in again.',
  file_download_start: 'The file download has started.',
  file_download_fail: 'Failed to download the file. Try again later.',
  delete_file_fail: 'Can not delete the file from storage.',
  file_not_exist: "The file doesn't exist.",
  checkout_fail: 'The checkout process failed or pending.',
  subscription_not_found: 'No Subscription is found.',
  try_again_later: 'Please try again later.',
  try_again_later_payment:
    'We are currently having issues contacting our payment provider. Please try again later.',
  sms_send_success: 'SMS was sent successfully.',
  max_appointees_fail: 'You already have max appointees allowed.',
  no_subscription: 'No subscription present.',
  user_delete_success: 'The User is deleted successfully.',
  this_contact_account: 'This is a contact account.',
  unauthorized_access: 'Access is unauthorized.',
  authentincation_error:
    'An error occurred in the authentication process. Please log in again.',
  user_is_contact: 'The user is itself a contact.',
  user_is_user: 'The user is itself a vault user.',
  admin_not_exist: "The Admin doesn't exist.",
  admin_signin_error: 'An error occurred in Admin sign-in process.',
  user_not_exist: "The User doesn't exist.",
  user_signin_error: 'An error occurred in User sign-in process.',
  user_not_active: 'The user is not active.',
  contact_not_exist: "The Contact doesn't exist.",
  contact_not_associated: 'The Contact is not associated with a user.',
  connection_exists: 'connection_exists',
  contact_none_not_valid:
    'Setting role to None is not allowed since it is not tied to any items.',
  can_not_make_id: 'Can not make any ID at this moment.',
  token_not_present: 'Token is not present.',
  session_not_found: 'Session is not found.',
  session_expired: 'The session has expired.',
  email_exists: 'The provided email already exists.',
  email_not_exists: 'The provided email does not exist.',
  email_sent: 'An email is sent. Please check your mail.',
  recover_keys_fail: 'We are unable to recover keys correctly.',
  recover_keys_fail_excep: 'We are unable to recover keys correctly.',
  user_not_deceased: 'The user is not deceased.',
  pending_email_change:
    'There is a pending email change that needs to be verified.',
  pending_mobile_phone_number_change:
    'There is a pending mobile phone number change that needs to be verified.',
  confirm_email_required: 'Confirm Email is required.',
  email_not_match: 'Emails does not match.',
  phone_not_match: 'Phone numbers does not match.',
  email_phone_change_request_success: 'Change request submitted successfully.',
  email_phone_change_request_fail: 'Failed to submit the change request.',
  cancel_email_phone_change_success:
    'Canceled the change request successfully.',
  cancel_email_phone_change_fail: 'Failed to cancel the change request.',
  subscription_canceled:
    'You have successfully unsubscribed from the service. Your access will remain intact until the end of current subscription period.',
  start_date_and_discount:
    "Can't get discount and subscription start date for selected plan.",
  phone_change_requested: 'Phone number change is pending.',
  contact_already_exists: 'Contact with same email already exists.',
  refute_death: 'Refuted Successfully.',
  missing_payment_msg:
    'Your Coop (digital vault) is currently locked due to missing payment.',
  invalid_vault_key:
    'Your Coop (digital vault) is currently locked due to too many invalid access attempts. Please use Contact Us if this has happened in error. If you have lost your vault key and would like to request it please submit the Request New Encryption Key form.',
  user_can_not_login:
    'Your user status is in a state which is not eligible for login. Please use Contact Us if this has happened in error.',
  invalid_tfa: 'Invalid verification code entered.',
  invalid_tfa_limit_exceed:
    'Your account is currently locked due to too many invalid TFA access attempts. Please use Contact Us if this has happened in error.',
  non_active_user: 'Your user status is not active.',
  no_vault_action:
    "Your user status is in a state that doesn't have any action to perform in the vault area. Please use Contact Us if this has happened in error.",
  spouse_phone_error: 'Provided spouse phone number is not correct.',
  promotion_code_error: 'Entered promotion code is not correct.',
  resend_contact_invitation_success: 'Invitation mail sent successfully.',
  resend_contact_invitation_fail: 'Failed to send invitation mail.',
  duplicate_email_error:
    'We are unable to complete this request. Please use Contact Us if you feel you are getting this in error.',
  cant_load_address: "Can't load address of the contact.",
  invalid_account_number: 'The Account number is not valid.',
  invalid_policy_number: 'The Policy number is not valid.',
  file_decryption_started:
    'We are processing the file to download. Please wait.',
  user_has_suspention: 'user_has_suspention',
  token_expired: 'token_expired',
  token_expired_message:
    'This login link has expired. Please re-submit your email address to receive an email with a new login link.',
  invitation_token_expired: 'invitation_token_expired',
  contact_invitation_expired:
    'The invitation link has expired. Please contact the account owner to send another invitation email.',
  file_removed: 'File has been removed.',
  invalid_date_format: 'Date format is invalid.',
  date_cant_be_in_future: "Date can't be in future.",
  vault_cannt_recover:
    'The requested Coop (digital vault) is currently not available for viewing due to a key recovery issue. Please use Contact Us if this has happened in error.',
  vault_not_open:
    'The requested Coop (digital vault) is currently not available for viewing. Please use Contact Us if this has happened in error.',
  vault_user_not_provided:
    'Please specify the user id of the Coop (digital vault) to enter.',
  admin_missing_permission: "Current admin doesn't have proper access right.",
  user_suspend_success: 'User has been suspended successfully.',
  user_activate_success: 'User has been activated successfully.',
  duplicate_email_error_admin:
    'Another vault user with the same email already exists.',
  invalid_user_phone_number: 'The provided phone number is not valid.',
  already_have_courtesy_acct:
    'You are already using a free courtesy subscription.',
  do_not_qualify_courtesy_acct:
    'You do not qualify for a free courtesy subscription.',
  field_required: 'This field is required.',
  subscription_updated: 'User subscription updated successfully.',
  phone_not_valid_type:
    'Mobile phone has been flagged as invalid.  If you believe this is in error please reach out via Contact Us.',
  contact_us_update_successful: 'The ticket has been updated successfully.',
  create_contact_us_note_successful:
    'The contact us note has been created successfully.',
  tax_accountant_added_successfully:
    'The tax accountant has been added successfully.',
  tax_accountant_deleted_successfully:
    'The tax accountant has been deleted successfully.',
  tax_accountant_updated_successfully:
    'The tax accountant has been updated successfully.',
  tax_basis_added_successfully: 'The tax basis has been added successfully.',
  tax_basis_deleted_successfully:
    'The tax basis has been deleted successfully.',
  tax_basis_updated_successfully:
    'The tax basis has been updated successfully.',
};
